// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function FingerprintBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M20 16c0 4.601-1.133 9.132-3.296 13.192a1.5 1.5 0 1 1-2.645-1.415A25.042 25.042 0 0 0 16.999 16a1 1 0 1 0-2 0 1.5 1.5 0 1 1-3 0 4 4 0 0 1 8 0Zm-4-9a1.5 1.5 0 0 0 0 3 6.007 6.007 0 0 1 6 6c0 .953-.045 1.915-.134 2.859a1.5 1.5 0 0 0 1.351 1.641h.143a1.5 1.5 0 0 0 1.491-1.359C24.95 18.104 25 17.046 25 16a9.01 9.01 0 0 0-9-9Zm-4 4.529a1.5 1.5 0 0 0-2-2.235A9.012 9.012 0 0 0 7 16c0 2.553-.65 5.064-1.89 7.296a1.502 1.502 0 0 0 2.625 1.462A18.018 18.018 0 0 0 10 16a6.01 6.01 0 0 1 2-4.471Zm1.262 8.012a1.498 1.498 0 0 0-1.807 1.113 19.825 19.825 0 0 1-2.36 5.732 1.5 1.5 0 0 0 2.562 1.56 22.853 22.853 0 0 0 2.718-6.597 1.498 1.498 0 0 0-1.113-1.808Zm9.592 3.009a1.499 1.499 0 0 0-1.83 1.075 30.181 30.181 0 0 1-1 3.109 1.5 1.5 0 0 0 2.8 1.072 32.49 32.49 0 0 0 1.1-3.421 1.5 1.5 0 0 0-1.07-1.835ZM16 2A14.015 14.015 0 0 0 2 15.93v.071a9.977 9.977 0 0 1-.625 3.478 1.5 1.5 0 1 0 2.812 1.044c.53-1.425.805-2.931.813-4.45V16a11 11 0 0 1 22-.062V16c0 2.58-.282 5.154-.843 7.673a1.5 1.5 0 1 0 2.93.654c.604-2.712.91-5.481.913-8.26v-.067A14.016 14.016 0 0 0 16 2Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
